import { defineStore } from "pinia";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {StorageSerializers, useStorage} from "@vueuse/core";

import type { User } from "firebase/auth";
import {PagesEnum} from "@/router";

type MaybeUser = User | null;

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    user: useStorage("user", null as MaybeUser, undefined, { serializer: StorageSerializers.object }),
  }),
  getters: {
    isLoggedIn(): boolean {
      return !!this.user;
    },
    getUser(): MaybeUser {
      return this.user;
    },
  },
  actions: {
    setUser(user: MaybeUser) {
      this.user = user;
    },
    async register(email: string, password: string) {
      try {
        await createUserWithEmailAndPassword(
            getAuth(),
            email,
            password
        );
      } catch (e) {
        throw new Error("Signup failed");
      }
    },

    async login(email: string, password: string) {
      try {
        await signInWithEmailAndPassword(
            getAuth(),
            email,
            password
        );
      } catch (e) {
        throw new Error("Login failed");
      }
    },

    async logout() {
      await signOut(getAuth());
      // @ts-ignore
      await this.router.push({name: PagesEnum.SIGN_IN});
    },
  },
});
